const measurementButtons = document.querySelectorAll('.js-measurement-guide-button');
const measurementTable = document.getElementById('measurement-table');
const defaultSizeSelected = 'data-cm';

if(measurementButtons) {
    measurementButtons.forEach(button => {
        button.addEventListener('click', function () {
          measurementButtons.forEach(btn => btn.classList.remove('is-active'));
          button.classList.add('is-active');
          const attribute = button.dataset.measure;
          updateMeasurementTableContent(attribute);
        });
      });
}

function updateMeasurementTableContent(attribute) {
  const rows = measurementTable.querySelectorAll('tbody tr');
  rows.forEach(row => {
    const cells = row.querySelectorAll('td');
    cells.forEach(cell => {
      cell.textContent = cell.getAttribute(attribute);
    });
  });
}

if(measurementTable) {
    updateMeasurementTableContent(defaultSizeSelected);
}





// WEBPACK FOOTER //
// ./scripts/components/size-guide.js